import { defineComponent as _defineComponent } from 'vue'
interface LegendaItem {
	class: string;
	description: string;
}

interface Props {
	/** Array di elementi della legenda */
	items?: LegendaItem[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LegendaTooltip',
  props: {
    items: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { items: LegendaItem[] };

/**
 * LegendaTooltip - Componente per mostrare la legenda dei colori tabella
 *
 * Versione minimale con icona info e tooltip. Sostituisce il componente
 * Legenda.vue con un approccio meno invadente.
 *
 * @example
 * <LegendaTooltip :items="legendaItems" />
 */



return { __sfc: true,props }
}

})